const defaultState = {
  channels: {},
  videos: {},
};

export default function (state = defaultState, { payload }) {
  const entities = _.get(payload, 'response.data.entities');

  if (entities) {
    state = _.mergeWith({}, state, entities, function (a, b) {
      if (_.isArray(a)) {
        return b;
      }
    });
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/widget/redux/client/reducers/entities.js